export default __webpack_public_path__ + "static/media/placeholder_dummy2016-eventagentur01-de-mobile.ab835430.png";